module.exports = __webpack_public_path__ + "img/Pattern04.e1487186.png";